import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ITextBlockSchemaProps } from '../components/text-block-schema/text-block-schema';

export class TextBlockSchemaModel extends ContentItem {
  get text(): string {
    return get(this._config, 'elements.text_value.value', '');
  }

  get hasArrow(): boolean {
    return get(this._config, 'elements.has_arrow.value[0].codename') === 'true';
  }

  public static create(data: ITextBlockSchema): ITextBlockSchemaProps {
    const { text, hasArrow } = new TextBlockSchemaModel(data);
    return {
      text,
      hasArrow
    };
  }
}
